import React, { useContext, useEffect, useState } from "react";
import { useForm, useFieldArray, Controller, useWatch } from "react-hook-form";
import * as yup from "yup";
import {
  Box,
  Button,
  Typography,
  TextField,
  Stepper,
  Step,
  StepLabel,
  Container,
  Autocomplete,
  Chip,
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Card,
  Stack,
  CardContent,
  Divider,
  Alert,
  StepConnector,
  styled,
} from "@mui/material";
import guestServicesDetailsApi from "../../../api/guestServicesDetailsApi";
import RtlProvider from "../../../Components/RtlProvider";
import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import CustomDateInput from '../../../Components/CustomDateInput';
import moment from 'jalali-moment'
import CheckboxListFlex from "./CheckboxListFlex";
import guestGroupApi from "../../../api/guestGroupApi";
import Loading from "../../../Components/Loading";
import guestRequestApi from "../../../api/guestRequestApi";
import { ContextNotification, severitys } from "../../../App";
import stationApi from "../../../api/stationApi";
import { MdExpandMore, MdOutlineTrain, MdPerson } from "react-icons/md";
import enumMapper from "../../../enumMapper";
import { ContextUserInfo } from "../MainPanel";
import { useNavigate } from 'react-router-dom';
import { FaKaaba } from "react-icons/fa6";
import { FaCcVisa } from "react-icons/fa6";
import { FaHotel } from "react-icons/fa6";
import { GiHotMeal } from "react-icons/gi";
import { PiAirplaneInFlightFill } from "react-icons/pi";
import { FaCheck, FaRegCalendar } from "react-icons/fa";
import AddIcon from '@mui/icons-material/Add'; // ← این را فراموش نکنید
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';

function toGregorian(input) {
  if (!input) return null;

  let date = new DateObject({
    date: input,
    calendar: persian,
    locale: persian_fa
  });

  const dateStr = date.year + '/' + date.month.number + '/' + date.day;

  return moment.from(dateStr, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD');
}

const dateWithinTrip = (label, isRequired = false) =>
  yup.string()
    .test("within-trip", "تاریخ خارج از بازه سفر است", function (value) {
      // اگر خالی بود و اجباری نیست، قبول
      if (!value && !isRequired) return true;

      // اگر اجباریه و خالیه، fail
      if (!value && isRequired) return this.createError({ message: `${label} را انتخاب نمایید` });

      const { startTrip, endTrip } = this.options.context || {};
      if (!startTrip || !endTrip) return true;

      const valueG = toGregorian(value);
      const startG = toGregorian(startTrip);
      const endG = toGregorian(endTrip);

      return valueG >= startG && valueG <= endG;
    });

/* ------------------ Yup Schemas ------------------ */
const stepSchemas = {
  TravelPeriodStep: yup.object({
    startTrip: yup.string().required("از تاریخ را انتخاب نمایید"),
    endTrip: yup.string().required("تا تاریخ را انتخاب نمایید"),
  }),

  Plan_Mecca: yup.object({
    items: yup.array().of(
      yup.object({
        hotelId: yup.object().nullable().required("هتل را انتخاب نمایید"),
        guestServiceType: yup.object().nullable().required("نوع اتاق را انتخاب نمایید"),
        from: dateWithinTrip("از تاریخ", true),
        to: dateWithinTrip("تا تاریخ", true),
        selectPassengersId: yup.array().default([]).min(1, 'حداقل یک نفر انتخاب نمایید'),
      })
    ).min(1, "At least one item is required"),
  }),

  Visa: yup.object({
    items: yup.array().of(
      yup.object({
        selectPassengersId: yup.array().default([]).min(1, 'حداقل یک نفر انتخاب نمایید'),
      })
    ).min(1, "At least one item is required")
  }),

  Nutrition_Mecca: yup.object({
    items: yup.array().of(
      yup.object({
        stArr: yup.array().default([]).min(1, 'حداقل یک وعده غذایی انتخاب نمایید'),
        from: dateWithinTrip("از تاریخ", true),
        to: dateWithinTrip("تا تاریخ", true),
        selectPassengersId: yup.array().default([]).min(1, 'حداقل یک نفر انتخاب نمایید'),
      })
    ).min(1, "At least one item is required")

  }),

  Transfer_Mecca: yup.object({
    items: yup.array().of(
      yup.object({
        guestServiceType: yup.object().nullable().required("نوع سرویس نقل را انتخاب نمایید"),
        from: dateWithinTrip("از تاریخ", false),
        to: dateWithinTrip("تا تاریخ", false),
        selectPassengersId: yup.array().default([]).min(1, 'حداقل یک نفر انتخاب نمایید'),
      })
    ).min(1, "At least one item is required")
  }),

  Plan_Medina: yup.object({
    items: yup.array().of(
      yup.object({
        hotelId: yup.object().nullable().required("هتل را انتخاب نمایید"),
        guestServiceType: yup.object().nullable().required("نوع اتاق را انتخاب نمایید"),
        from: dateWithinTrip("از تاریخ", true),
        to: dateWithinTrip("تا تاریخ", true),
        selectPassengersId: yup.array().default([]).min(1, 'حداقل یک نفر انتخاب نمایید'),
      })
    ).min(1, "At least one item is required")
  }),

  Nutrition_Medina: yup.object({
    items: yup.array().of(
      yup.object({
        stArr: yup.array().default([]).min(1, 'حداقل یک وعده غذایی انتخاب نمایید'),
        from: dateWithinTrip("از تاریخ", true),
        to: dateWithinTrip("تا تاریخ", true),
        selectPassengersId: yup.array().default([]).min(1, 'حداقل یک نفر انتخاب نمایید'),
      })
    ).min(1, "At least one item is required")
  }),

  Transfer_Medina: yup.object({
    items: yup.array().of(
      yup.object({
        guestServiceType: yup.object().nullable().required("Select tranfer type"),
        from: dateWithinTrip("از تاریخ", false),
        to: dateWithinTrip("تا تاریخ", false),
        selectPassengersId: yup.array().default([]).min(1, 'حداقل یک نفر انتخاب نمایید'),
      })
    ).min(1, "At least one item is required")
  }),

  Flight: yup.object({
    items: yup.array().of(
      yup.object({
        from: dateWithinTrip("از تاریخ", true),
        to: dateWithinTrip("تا تاریخ", true),
        selectPassengersId: yup.array().default([]).min(1, 'حداقل یک نفر انتخاب نمایید'),
      })
    ).min(1, "At least one item is required")
  }),

};

/* ------------------ Step Components ------------------ */
// Step 1: always visible
function TravelPeriodStep({ control, register, errors, clearErrors }) {
  return (
    <Box class="mybox">
      <Grid container spacing={2}>
        <Grid item md={6}>
          <Controller
            control={control}
            name="TravelPeriodStep.startTrip"
            rules={{ required: true }}
            render={({
              field: { onChange, name, value },
              fieldState: { invalid, isDirty },
            }) => (
              <>
                <DatePicker
                  value={value || ""}
                  onChange={(date) => {
                    onChange(date?.isValid ? date : "");
                    clearErrors("TravelPeriodStep.startTrip")
                  }}
                  format={"YYYY/MM/DD"}
                  calendar={persian}
                  locale={persian_fa}
                  calendarPosition="bottom-right"
                  render={<CustomDateInput label={"از تاریخ"}
                    error={!!errors?.TravelPeriodStep?.startTrip}
                    helperText={errors?.TravelPeriodStep?.startTrip?.message}

                  />}
                />
              </>
            )}
          />
        </Grid>
        <Grid item md={6}>
          <Controller
            control={control}
            name="TravelPeriodStep.endTrip"
            rules={{ required: true }}
            render={({
              field: { onChange, name, value },
              fieldState: { invalid, isDirty },
            }) => (
              <>
                <DatePicker
                  value={value || ""}
                  onChange={(date) => {
                    onChange(date?.isValid ? date : "");
                    clearErrors("TravelPeriodStep.endTrip")
                  }}
                  format={"YYYY/MM/DD"}
                  calendar={persian}
                  locale={persian_fa}
                  calendarPosition="bottom-right"
                  render={<CustomDateInput label={"تا تاریخ"}
                    error={!!errors?.TravelPeriodStep?.endTrip}
                    helperText={errors?.TravelPeriodStep?.endTrip?.message}
                  />}
                />
              </>
            )}
          />
        </Grid>
      </Grid>
    </Box>
  );
}

function Visa({
  control,
  errors,
  watch,
  clearErrors,
  stepData,   // API data
  commonData,
  register
}) {
  const { fields, append, remove } = useFieldArray({
    control,
    name: "Visa.items",
  });

  const apiItems = stepData?.items || [];

  // unique visaServiceTypes from API
  const visaServiceTypes = React.useMemo(() => {
    const map = new Map();
    apiItems.forEach((i) => {
      if (i.guestServiceType.toString()) {
        map.set(i.guestServiceType.toString(), {
          guestServiceType: i.guestServiceType.toString(),
          guestServiceTypeTitle: i.guestServiceTypeTitle,
        });
      }
    });
    return Array.from(map.values());
  }, [apiItems]);

  return (
    <Box display="flex" flexDirection="column" gap={2}>

      {fields.map((field, index) => {
        return (
          <Box key={field.id} class="mybox">
            <input
              type="hidden"
              {...register(`Visa.items.${index}.guestServiceType`)}
            />

            <CheckboxListFlex
              name={`Visa.items.${index}.selectPassengersId`}
              control={control}
              items={commonData?.allMembers}
              label="انتخاب نفرات"
              direction="row"
              spacing={1}
              onChange={() => { clearErrors(`Visa.items.${index}.selectPassengersId`); }} // <-- parent onChange
            />

            {/* <Button variant="outlined" color="error" onClick={() => remove(index)}>
              حذف
            </Button> */}
          </Box>
        );
      })}


      {errors?.Visa?.items?.message && (
        <Typography color="error">
          {errors.Visa.items.message}
        </Typography>
      )}
    </Box>
  );
}

function Plan_Mecca({
  control,
  errors,
  watch,
  clearErrors,
  stepData,   // API data
  commonData
}) {
  const { fields, append, remove } = useFieldArray({
    control,
    name: "Plan_Mecca.items",
  });

  const apiItems = stepData?.items || [];

  // unique hotels from API
  const hotels = React.useMemo(() => {
    const map = new Map();
    apiItems.forEach((i) => {
      if (i.hotelId) {
        map.set(i.hotelId, {
          hotelId: i.hotelId,
          title: i.title,
        });
      }
    });
    return Array.from(map.values());
  }, [apiItems]);


  return (
    <Box display="flex" flexDirection="column" gap={2}>

      {fields.map((field, index) => {
        const selectedHotel = watch(`Plan_Mecca.items.${index}.hotelId`);

        const services = selectedHotel
          ? apiItems.filter(
            (i) => i.hotelId === selectedHotel.hotelId
          )
          : [];

        return (
          <Box key={field.id} class="mybox">
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} md={6}>

                {/* Hotel dropdown */}
                <Controller
                  name={`Plan_Mecca.items.${index}.hotelId`}
                  control={control}
                  render={({ field }) => (
                    <Autocomplete
                      {...field}
                      options={hotels}
                      getOptionLabel={(o) => o?.title || ""}
                      onChange={(_, value) => {
                        field.onChange(value);
                        clearErrors(`Plan_Mecca.items.${index}.hotelId`);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="هتل"
                          error={!!errors?.Plan_Mecca?.items?.[index]?.hotelId}
                          helperText={
                            errors?.Plan_Mecca?.items?.[index]?.hotelId?.message
                          }
                        />
                      )}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={6}>
                {/* Service dropdown */}
                <Controller
                  name={`Plan_Mecca.items.${index}.guestServiceType`}
                  control={control}
                  render={({ field }) => (
                    <Autocomplete
                      {...field}
                      options={services}
                      getOptionLabel={(o) => o?.guestServiceTypeTitle || ""}
                      disabled={!selectedHotel}
                      //onChange={(_, value) => field.onChange(value)}
                      onChange={(_, value) => {
                        field.onChange(value);
                        // reset service when hotel changes
                        clearErrors(`Plan_Mecca.items.${index}.guestServiceType`);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="تعداد تخت"
                          error={!!errors?.Plan_Mecca?.items?.[index]?.guestServiceType}
                          helperText={
                            errors?.Plan_Mecca?.items?.[index]?.guestServiceType?.message
                          }
                        />
                      )}
                    />
                  )}
                />
              </Grid>
              <Grid item md={6}>

                <Controller
                  control={control}
                  name={`Plan_Mecca.items.${index}.from`}
                  rules={{ required: true }}
                  render={({
                    field: { onChange, name, value },
                    fieldState: { invalid, isDirty },
                  }) => (
                    <>
                      <DatePicker
                        value={value || ""}
                        onChange={(date) => {
                          onChange(date?.isValid ? date : "");
                          clearErrors(`Plan_Mecca.items.${index}.from`);
                        }}
                        format={"YYYY/MM/DD"}
                        calendar={persian}
                        locale={persian_fa}
                        calendarPosition="bottom-right"
                        render={<CustomDateInput label={"از تاریخ"}
                          error={!!errors?.Plan_Mecca?.items?.[index]?.from}
                          helperText={
                            errors?.Plan_Mecca?.items?.[index]?.from?.message
                          }

                        />}
                      />
                    </>
                  )}
                />
              </Grid>
              <Grid item md={6}>
                <Controller
                  control={control}
                  name={`Plan_Mecca.items.${index}.to`}
                  rules={{ required: true }}
                  render={({
                    field: { onChange, name, value },
                    fieldState: { invalid, isDirty },
                  }) => (
                    <>
                      <DatePicker
                        value={value || ""}
                        onChange={(date) => {
                          onChange(date?.isValid ? date : "");
                          clearErrors(`Plan_Mecca.items.${index}.to`);
                        }}
                        format={"YYYY/MM/DD"}
                        calendar={persian}
                        locale={persian_fa}
                        calendarPosition="bottom-right"
                        render={<CustomDateInput label={"تا تاریخ"}
                          error={!!errors?.Plan_Mecca?.items?.[index]?.to}
                          helperText={
                            errors?.Plan_Mecca?.items?.[index]?.to?.message
                          }
                        />}
                      />
                    </>
                  )}
                />
              </Grid>
              <Grid item md={12}>
                <CheckboxListFlex
                  name={`Plan_Mecca.items.${index}.selectPassengersId`}
                  control={control}
                  items={commonData?.allMembers}
                  label="انتخاب نفرات"
                  direction="row"
                  spacing={1}
                  onChange={() => { clearErrors(`Plan_Mecca.items.${index}.selectPassengersId`); }} // <-- parent onChange
                />
              </Grid>
              {fields.length > 1 && (<Grid item md={12}>
                <Button variant="outlined" color="error" onClick={() => remove(index)}>
                  حذف
                </Button>
              </Grid>
              )
              }
            </Grid>
          </Box>
        );
      })}

      <Button
        onClick={() =>
          append({
            hotelId: null,
            guestServiceType: null,
            selectPassengersId: [],
            from: "",
            to: "",
          })
        }
        variant="text"
        color="primary"
        startIcon={<AddIcon />}
        sx={{ padding: 0, textTransform: 'none', fontSize: 14 }}
      >
         افزودن درخواست {stepData?.title}
      </Button>

      {errors?.Plan_Mecca?.items?.message && (
        <Typography color="error">
          {errors.Plan_Mecca.items.message}
        </Typography>
      )}
    </Box>
  );
}

function Nutrition_Mecca({
  control,
  errors,
  watch,
  clearErrors,
  stepData,   // API data
  commonData
}) {
  const { fields, append, remove } = useFieldArray({
    control,
    name: "Nutrition_Mecca.items",
  });

  const apiItems = stepData?.items || [];

  // unique nutritionServiceTypes from API
  const nutritionServiceTypes = React.useMemo(() => {
    const map = new Map();
    apiItems.forEach((i) => {
      if (i.guestServiceType.toString()) {
        map.set(i.guestServiceType.toString(), {
          guestServiceType: i.guestServiceType.toString(),
          guestServiceTypeTitle: i.guestServiceTypeTitle,
        });
      }
    });
    return Array.from(map.values());
  }, [apiItems]);


  const nutritionServiceTypes2 = React.useMemo(() => {
    const map = new Map();
    apiItems.forEach((i) => {
      if (i.guestServiceType.toString()) {
        map.set(i.guestServiceType.toString(), {
          id: i.guestServiceType.toString(),
          label: i.guestServiceTypeTitle,
        });
      }
    });
    return Array.from(map.values());
  }, [apiItems]);


  return (
    <Box display="flex" flexDirection="column" gap={2}>

      {fields.map((field, index) => {

        return (
          <Box key={field.id} class="mybox">
            <Grid container spacing={2}>
              <Grid item md={12}>
                <CheckboxListFlex
                  name={`Nutrition_Mecca.items.${index}.stArr`}
                  control={control}
                  items={nutritionServiceTypes2}
                  label="نوع سرویس تغذیه"
                  direction="row"
                  spacing={1}
                  onChange={() => { clearErrors(`Nutrition_Mecca.items.${index}.stArr`); }} // <-- parent onChange
                  selectAllLabel="وعده های کامل غذایی"
                />
              </Grid>

              <Grid item md={6}>
                <Controller
                  control={control}
                  name={`Nutrition_Mecca.items.${index}.from`}
                  rules={{ required: true }}
                  render={({
                    field: { onChange, name, value },
                    fieldState: { invalid, isDirty },
                  }) => (
                    <>
                      <DatePicker
                        value={value || ""}
                        onChange={(date) => {
                          onChange(date?.isValid ? date : "");
                          clearErrors(`Nutrition_Mecca.items.${index}.from`);
                        }}
                        format={"YYYY/MM/DD"}
                        calendar={persian}
                        locale={persian_fa}
                        calendarPosition="bottom-right"
                        render={<CustomDateInput label={"از تاریخ"}
                          error={!!errors?.Nutrition_Mecca?.items?.[index]?.from}
                          helperText={
                            errors?.Nutrition_Mecca?.items?.[index]?.from?.message
                          }

                        />}
                      />
                    </>
                  )}
                />
              </Grid>

              <Grid item md={6}>
                <Controller
                  control={control}
                  name={`Nutrition_Mecca.items.${index}.to`}
                  rules={{ required: true }}
                  render={({
                    field: { onChange, name, value },
                    fieldState: { invalid, isDirty },
                  }) => (
                    <>
                      <DatePicker
                        value={value || ""}
                        onChange={(date) => {
                          onChange(date?.isValid ? date : "");
                          clearErrors(`Nutrition_Mecca.items.${index}.to`);
                        }}
                        format={"YYYY/MM/DD"}
                        calendar={persian}
                        locale={persian_fa}
                        calendarPosition="bottom-right"
                        render={<CustomDateInput label={"تا تاریخ"}
                          error={!!errors?.Nutrition_Mecca?.items?.[index]?.to}
                          helperText={
                            errors?.Nutrition_Mecca?.items?.[index]?.to?.message
                          }
                        />}
                      />
                    </>
                  )}
                />
              </Grid>

              <Grid item md={12}>
                <CheckboxListFlex
                  name={`Nutrition_Mecca.items.${index}.selectPassengersId`}
                  control={control}
                  items={commonData?.allMembers}
                  label="انتخاب نفرات"
                  direction="row"
                  spacing={1}
                  onChange={() => { clearErrors(`Nutrition_Mecca.items.${index}.selectPassengersId`); }} // <-- parent onChange
                />
              </Grid>
              {fields.length > 1 && (<Grid item md={12}>
                <Button variant="outlined" color="error" onClick={() => remove(index)}>
                  حذف
                </Button>
              </Grid>
              )
              }
            </Grid>
          </Box>
        );
      })}

      <Button
        onClick={() =>
          append({
            guestServiceType: null,
            stArr: [],
            selectPassengersId: [],
            from: "",
            to: "",
          })
        }
        variant="text"
        color="primary"
        startIcon={<AddIcon />}
        sx={{ padding: 0, textTransform: 'none', fontSize: 14 }}
      >
         افزودن درخواست {stepData?.title}
      </Button>

      {errors?.Nutrition_Mecca?.items?.message && (
        <Typography color="error">
          {errors.Nutrition_Mecca.items.message}
        </Typography>
      )}
    </Box>
  );
}

function Transfer_Mecca({
  control,
  errors,
  watch,
  clearErrors,
  stepData,   // API data
  commonData
}) {
  const { fields, append, remove } = useFieldArray({
    control,
    name: "Transfer_Mecca.items",
  });

  const apiItems = stepData?.items || [];

  // unique transferServiceTypes from API
  const transferServiceTypes = React.useMemo(() => {
    const map = new Map();
    apiItems.forEach((i) => {
      if (i.guestServiceType.toString()) {
        map.set(i.guestServiceType.toString(), {
          guestServiceType: i.guestServiceType.toString(),
          guestServiceTypeTitle: i.guestServiceTypeTitle,
        });
      }
    });
    return Array.from(map.values());
  }, [apiItems]);

  return (
    <Box display="flex" flexDirection="column" gap={2}>

      {fields.map((field, index) => {

        return (
          <Box key={field.id} class="mybox">

            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12}>
                {/* Service dropdown */}
                <Controller
                  name={`Transfer_Mecca.items.${index}.guestServiceType`}
                  control={control}
                  render={({ field }) => (
                    <Autocomplete
                      {...field}
                      options={transferServiceTypes}
                      getOptionLabel={(o) => o?.guestServiceTypeTitle || ""}

                      onChange={(_, value) => {
                        field.onChange(value);
                        clearErrors(`Transfer_Mecca.items.${index}.guestServiceType`);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="نوع سرویس نقل"
                          error={!!errors?.Transfer_Mecca?.items?.[index]?.guestServiceType}
                          helperText={
                            errors?.Transfer_Mecca?.items?.[index]?.guestServiceType?.message
                          }
                        />
                      )}
                    />
                  )}
                />
              </Grid>
              <Grid item md={6}>
                <Controller
                  control={control}
                  name={`Transfer_Mecca.items.${index}.from`}
                  rules={{ required: true }}
                  render={({
                    field: { onChange, name, value },
                    fieldState: { invalid, isDirty },
                  }) => (
                    <>
                      <DatePicker
                        value={value || ""}
                        onChange={(date) => {
                          onChange(date?.isValid ? date : "");
                          clearErrors(`Transfer_Mecca.items.${index}.from`);
                        }}
                        format={"YYYY/MM/DD"}
                        calendar={persian}
                        locale={persian_fa}
                        calendarPosition="bottom-right"
                        render={<CustomDateInput label={"از تاریخ"}
                          error={!!errors?.Transfer_Mecca?.items?.[index]?.from}
                          helperText={
                            errors?.Transfer_Mecca?.items?.[index]?.from?.message
                          }

                        />}
                      />
                    </>
                  )}
                />
              </Grid>
              <Grid item md={6}>
                <Controller
                  control={control}
                  name={`Transfer_Mecca.items.${index}.to`}
                  rules={{ required: true }}
                  render={({
                    field: { onChange, name, value },
                    fieldState: { invalid, isDirty },
                  }) => (
                    <>
                      <DatePicker
                        value={value || ""}
                        onChange={(date) => {
                          onChange(date?.isValid ? date : "");
                          clearErrors(`Transfer_Mecca.items.${index}.to`);
                        }}
                        format={"YYYY/MM/DD"}
                        calendar={persian}
                        locale={persian_fa}
                        calendarPosition="bottom-right"
                        render={<CustomDateInput label={"تا تاریخ"}
                          error={!!errors?.Transfer_Mecca?.items?.[index]?.to}
                          helperText={
                            errors?.Transfer_Mecca?.items?.[index]?.to?.message
                          }
                        />}
                      />
                    </>
                  )}
                />
              </Grid>
              <Grid item md={12}>
                <CheckboxListFlex
                  name={`Transfer_Mecca.items.${index}.selectPassengersId`}
                  control={control}
                  items={commonData?.allMembers}
                  label="انتخاب نفرات"
                  direction="row"
                  spacing={1}
                  onChange={() => { clearErrors(`Transfer_Mecca.items.${index}.selectPassengersId`); }} // <-- parent onChange
                />
              </Grid>
              {fields.length > 1 && (<Grid item md={12}>
                <Button variant="outlined" color="error" onClick={() => remove(index)}>
                  حذف
                </Button>
              </Grid>
              )
              }
            </Grid>
          </Box>
        );
      })}

      <Button
        onClick={() =>
          append({
            guestServiceType: null,
            selectPassengersId: [],
            from: "",
            to: "",
          })
        }
        variant="text"
        color="primary"
        startIcon={<AddIcon />}
        sx={{ padding: 0, textTransform: 'none', fontSize: 14 }}
      >
         افزودن درخواست {stepData?.title}
      </Button>

      {errors?.Transfer_Mecca?.items?.message && (
        <Typography color="error">
          {errors.Transfer_Mecca.items.message}
        </Typography>
      )}
    </Box>
  );
}

function Plan_Medina({
  control,
  errors,
  watch,
  clearErrors,
  stepData,   // API data
  commonData
}) {
  const { fields, append, remove } = useFieldArray({
    control,
    name: "Plan_Medina.items",
  });

  const apiItems = stepData?.items || [];

  // unique hotels from API
  const hotels = React.useMemo(() => {
    const map = new Map();
    apiItems.forEach((i) => {
      if (i.hotelId) {
        map.set(i.hotelId, {
          hotelId: i.hotelId,
          title: i.title,
        });
      }
    });
    return Array.from(map.values());
  }, [apiItems]);

  return (
    <Box display="flex" flexDirection="column" gap={2}>

      {fields.map((field, index) => {
        const selectedHotel = watch(`Plan_Medina.items.${index}.hotelId`);

        const services = selectedHotel
          ? apiItems.filter(
            (i) => i.hotelId === selectedHotel.hotelId
          )
          : [];

        return (
          <Box key={field.id} class="mybox">
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={6}>
                {/* Hotel dropdown */}
                <Controller
                  name={`Plan_Medina.items.${index}.hotelId`}
                  control={control}
                  render={({ field }) => (
                    <Autocomplete
                      {...field}
                      options={hotels}
                      getOptionLabel={(o) => o?.title || ""}
                      onChange={(_, value) => {
                        field.onChange(value);
                        clearErrors(`Plan_Medina.items.${index}.hotelId`);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="هتل"
                          error={!!errors?.Plan_Medina?.items?.[index]?.hotelId}
                          helperText={
                            errors?.Plan_Medina?.items?.[index]?.hotelId?.message
                          }
                        />
                      )}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6}>
                {/* GuestServiceType dropdown */}
                <Controller
                  name={`Plan_Medina.items.${index}.guestServiceType`}
                  control={control}
                  render={({ field }) => (
                    <Autocomplete
                      {...field}
                      options={services}
                      getOptionLabel={(o) => o?.guestServiceTypeTitle || ""}
                      disabled={!selectedHotel}
                      //onChange={(_, value) => field.onChange(value)}
                      onChange={(_, value) => {
                        field.onChange(value);
                        // reset service when hotel changes
                        clearErrors(`Plan_Medina.items.${index}.guestServiceType`);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="تعداد تخت"
                          error={!!errors?.Plan_Medina?.items?.[index]?.guestServiceType}
                          helperText={
                            errors?.Plan_Medina?.items?.[index]?.guestServiceType?.message
                          }
                        />
                      )}
                    />
                  )}
                />
              </Grid>
              <Grid item md={6}>
                <Controller
                  control={control}
                  name={`Plan_Medina.items.${index}.from`}
                  rules={{ required: true }}
                  render={({
                    field: { onChange, name, value },
                    fieldState: { invalid, isDirty },
                  }) => (
                    <>
                      <DatePicker
                        value={value || ""}
                        onChange={(date) => {
                          onChange(date?.isValid ? date : "");
                          clearErrors(`Plan_Medina.items.${index}.from`);
                        }}
                        format={"YYYY/MM/DD"}
                        calendar={persian}
                        locale={persian_fa}
                        calendarPosition="bottom-right"
                        render={<CustomDateInput label={"از تاریخ"}
                          error={!!errors?.Plan_Medina?.items?.[index]?.from}
                          helperText={
                            errors?.Plan_Medina?.items?.[index]?.from?.message
                          }

                        />}
                      />
                    </>
                  )}
                />
              </Grid>
              <Grid item md={6}>
                <Controller
                  control={control}
                  name={`Plan_Medina.items.${index}.to`}
                  rules={{ required: true }}
                  render={({
                    field: { onChange, name, value },
                    fieldState: { invalid, isDirty },
                  }) => (
                    <>
                      <DatePicker
                        value={value || ""}
                        onChange={(date) => {
                          onChange(date?.isValid ? date : "");
                          clearErrors(`Plan_Medina.items.${index}.to`);
                        }}
                        format={"YYYY/MM/DD"}
                        calendar={persian}
                        locale={persian_fa}
                        calendarPosition="bottom-right"
                        render={<CustomDateInput label={"تا تاریخ"}
                          error={!!errors?.Plan_Medina?.items?.[index]?.to}
                          helperText={
                            errors?.Plan_Medina?.items?.[index]?.to?.message
                          }
                        />}
                      />
                    </>
                  )}
                />
              </Grid>
              <Grid item md={12}>
                <CheckboxListFlex
                  name={`Plan_Medina.items.${index}.selectPassengersId`}
                  control={control}
                  items={commonData?.allMembers}
                  label="انتخاب نفرات"
                  direction="row"
                  spacing={1}
                  onChange={() => { clearErrors(`Plan_Medina.items.${index}.selectPassengersId`); }} // <-- parent onChange
                />
              </Grid>
              {fields.length > 1 && (<Grid item md={12}>
                <Button variant="outlined" color="error" onClick={() => remove(index)}>
                  حذف
                </Button>
              </Grid>
              )
              }
            </Grid>
          </Box>
        );
      })}

      <Button
        onClick={() =>
          append({
            hotelId: null,
            guestServiceType: null,
            selectPassengersId: [],
            from: "",
            to: "",
          })
        }
        variant="text"
        color="primary"
        startIcon={<AddIcon />}
        sx={{ padding: 0, textTransform: 'none', fontSize: 14 }}
      >
        افزون ردیف
      </Button>

      {errors?.Plan_Medina?.items?.message && (
        <Typography color="error">
          {errors.Plan_Medina.items.message}
        </Typography>
      )}
    </Box>
  );
}

function Nutrition_Medina({
  control,
  errors,
  watch,
  clearErrors,
  stepData,   // API data
  commonData
}) {
  const { fields, append, remove } = useFieldArray({
    control,
    name: "Nutrition_Medina.items",
  });

  const apiItems = stepData?.items || [];

  // unique nutritionServiceTypes from API
  const nutritionServiceTypes = React.useMemo(() => {
    const map = new Map();
    apiItems.forEach((i) => {
      if (i.guestServiceType.toString()) {
        map.set(i.guestServiceType.toString(), {
          guestServiceType: i.guestServiceType.toString(),
          guestServiceTypeTitle: i.guestServiceTypeTitle,
        });
      }
    });
    return Array.from(map.values());
  }, [apiItems]);

  const nutritionServiceTypes2 = React.useMemo(() => {
    const map = new Map();
    apiItems.forEach((i) => {
      if (i.guestServiceType.toString()) {
        map.set(i.guestServiceType.toString(), {
          id: i.guestServiceType.toString(),
          label: i.guestServiceTypeTitle,
        });
      }
    });
    return Array.from(map.values());
  }, [apiItems]);

  return (
    <Box display="flex" flexDirection="column" gap={2}>

      {fields.map((field, index) => {

        return (
          <Box key={field.id} class="mybox">
            <Grid container spacing={2}>
              <Grid item md={12}>
                <CheckboxListFlex
                  name={`Nutrition_Medina.items.${index}.stArr`}
                  control={control}
                  items={nutritionServiceTypes2}
                  label="نوع سرویس تغذیه"
                  direction="row"
                  spacing={1}
                  onChange={() => { clearErrors(`Nutrition_Medina.items.${index}.stArr`); }} // <-- parent onChange
                  selectAllLabel="وعده های کامل غذایی"
                />
              </Grid>
              <Grid item md={6}>
                <Controller
                  control={control}
                  name={`Nutrition_Medina.items.${index}.from`}
                  rules={{ required: true }}
                  render={({
                    field: { onChange, name, value },
                    fieldState: { invalid, isDirty },
                  }) => (
                    <>
                      <DatePicker
                        value={value || ""}
                        onChange={(date) => {
                          onChange(date?.isValid ? date : "");
                          clearErrors(`Nutrition_Medina.items.${index}.from`);
                        }}
                        format={"YYYY/MM/DD"}
                        calendar={persian}
                        locale={persian_fa}
                        calendarPosition="bottom-right"
                        render={<CustomDateInput label={"از تاریخ"}
                          error={!!errors?.Nutrition_Medina?.items?.[index]?.from}
                          helperText={
                            errors?.Nutrition_Medina?.items?.[index]?.from?.message
                          }
                        />}
                      />
                    </>
                  )}
                />
              </Grid>
              <Grid item md={6}>
                <Controller
                  control={control}
                  name={`Nutrition_Medina.items.${index}.to`}
                  rules={{ required: true }}
                  render={({
                    field: { onChange, name, value },
                    fieldState: { invalid, isDirty },
                  }) => (
                    <>
                      <DatePicker
                        value={value || ""}
                        onChange={(date) => {
                          onChange(date?.isValid ? date : "");
                          clearErrors(`Nutrition_Medina.items.${index}.to`);
                        }}
                        format={"YYYY/MM/DD"}
                        calendar={persian}
                        locale={persian_fa}
                        calendarPosition="bottom-right"
                        render={<CustomDateInput label={"تا تاریخ"}
                          error={!!errors?.Nutrition_Medina?.items?.[index]?.to}
                          helperText={
                            errors?.Nutrition_Medina?.items?.[index]?.to?.message
                          }
                        />}
                      />
                    </>
                  )}
                />
              </Grid>
              <Grid item md={12}>
                <CheckboxListFlex
                  name={`Nutrition_Medina.items.${index}.selectPassengersId`}
                  control={control}
                  items={commonData?.allMembers}
                  label="انتخاب نفرات"
                  direction="row"
                  spacing={1}
                  onChange={() => { clearErrors(`Nutrition_Medina.items.${index}.selectPassengersId`); }} // <-- parent onChange
                />
              </Grid>
              {fields.length > 1 && (<Grid item md={12}>
                <Button variant="outlined" color="error" onClick={() => remove(index)}>
                  حذف
                </Button>
              </Grid>
              )
              }
            </Grid>
          </Box>
        );
      })}

      <Button
        onClick={() =>
          append({
            guestServiceType: null,
            stArr: [],
            selectPassengersId: [],
            from: "",
            to: "",
          })
        }
        variant="text"
        color="primary"
        startIcon={<AddIcon />}
        sx={{ padding: 0, textTransform: 'none', fontSize: 14 }}
      >
         افزودن درخواست {stepData?.title}
      </Button>

      {errors?.Nutrition_Medina?.items?.message && (
        <Typography color="error">
          {errors.Nutrition_Medina.items.message}
        </Typography>
      )}
    </Box>
  );
}

function Transfer_Medina({
  control,
  errors,
  watch,
  clearErrors,
  stepData,   // API data
  commonData
}) {
  const { fields, append, remove } = useFieldArray({
    control,
    name: "Transfer_Medina.items",
  });

  const apiItems = stepData?.items || [];

  // unique transferServiceTypes from API
  const transferServiceTypes = React.useMemo(() => {
    const map = new Map();
    apiItems.forEach((i) => {
      if (i.guestServiceType.toString()) {
        map.set(i.guestServiceType.toString(), {
          guestServiceType: i.guestServiceType.toString(),
          guestServiceTypeTitle: i.guestServiceTypeTitle,
        });
      }
    });
    return Array.from(map.values());
  }, [apiItems]);

  return (
    <Box display="flex" flexDirection="column" gap={2}>

      {fields.map((field, index) => {

        return (
          <Box key={field.id} class="mybox">
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12}>
                {/* Service dropdown */}
                <Controller
                  name={`Transfer_Medina.items.${index}.guestServiceType`}
                  control={control}
                  render={({ field }) => (
                    <Autocomplete
                      {...field}
                      options={transferServiceTypes}
                      getOptionLabel={(o) => o?.guestServiceTypeTitle || ""}

                      onChange={(_, value) => {
                        field.onChange(value);
                        clearErrors(`Transfer_Medina.items.${index}.guestServiceType`);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="نوع سرویس نقل"
                          error={!!errors?.Transfer_Medina?.items?.[index]?.guestServiceType}
                          helperText={
                            errors?.Transfer_Medina?.items?.[index]?.guestServiceType?.message
                          }
                        />
                      )}
                    />
                  )}
                />
              </Grid>
              <Grid item md={6}>
                <Controller
                  control={control}
                  name={`Transfer_Medina.items.${index}.from`}
                  rules={{ required: true }}
                  render={({
                    field: { onChange, name, value },
                    fieldState: { invalid, isDirty },
                  }) => (
                    <>
                      <DatePicker
                        value={value || ""}
                        onChange={(date) => {
                          onChange(date?.isValid ? date : "");
                          clearErrors(`Transfer_Medina.items.${index}.from`);
                        }}
                        format={"YYYY/MM/DD"}
                        calendar={persian}
                        locale={persian_fa}
                        calendarPosition="bottom-right"
                        render={<CustomDateInput label={"از تاریخ"}
                          error={!!errors?.Transfer_Medina?.items?.[index]?.from}
                          helperText={
                            errors?.Transfer_Medina?.items?.[index]?.from?.message
                          }

                        />}
                      />
                    </>
                  )}
                />
              </Grid>
              <Grid item md={6}>
                <Controller
                  control={control}
                  name={`Transfer_Medina.items.${index}.to`}
                  rules={{ required: true }}
                  render={({
                    field: { onChange, name, value },
                    fieldState: { invalid, isDirty },
                  }) => (
                    <>
                      <DatePicker
                        value={value || ""}
                        onChange={(date) => {
                          onChange(date?.isValid ? date : "");
                          clearErrors(`Transfer_Medina.items.${index}.to`);
                        }}
                        format={"YYYY/MM/DD"}
                        calendar={persian}
                        locale={persian_fa}
                        calendarPosition="bottom-right"
                        render={<CustomDateInput label={"تا تاریخ"}
                          error={!!errors?.Transfer_Medina?.items?.[index]?.to}
                          helperText={
                            errors?.Transfer_Medina?.items?.[index]?.to?.message
                          }
                        />}
                      />
                    </>
                  )}
                />
              </Grid>
              <Grid item md={12}>
                <CheckboxListFlex
                  name={`Transfer_Medina.items.${index}.selectPassengersId`}
                  control={control}
                  items={commonData?.allMembers}
                  label="انتخاب نفرات"
                  direction="row"
                  spacing={1}
                  onChange={() => { clearErrors(`Transfer_Medina.items.${index}.selectPassengersId`); }} // <-- parent onChange
                />
              </Grid>
              <Grid item md={12}>
                <Button variant="outlined" color="error" onClick={() => remove(index)}>
                  حذف
                </Button>
              </Grid>
            </Grid>
          </Box>
        );
      })}

      <Button
        onClick={() =>
          append({
            guestServiceType: null,
            selectPassengersId: [],
            from: "",
            to: "",
          })
        }
        variant="text"
        color="primary"
        startIcon={<AddIcon />}
        sx={{ padding: 0, textTransform: 'none', fontSize: 14 }}
      >
         افزودن درخواست {stepData?.title}
      </Button>

      {errors?.Transfer_Medina?.items?.message && (
        <Typography color="error">
          {errors.Transfer_Medina.items.message}
        </Typography>
      )}
    </Box>
  );
}

function Flight({
  control,
  setValue,
  errors,
  watch,
  clearErrors,
  stepData,   // API data
  commonData,
  register
}) {
  const { fields, append, remove } = useFieldArray({
    control,
    name: "Flight.items",
  });

  const apiItems = stepData?.items || [];

  // unique FlightServiceTypes from API
  const flightServiceTypes = React.useMemo(() => {
    const map = new Map();
    apiItems.forEach((i) => {
      if (i.guestServiceType.toString()) {
        map.set(i.guestServiceType.toString(), {
          guestServiceType: i.guestServiceType.toString(),
          guestServiceTypeTitle: i.guestServiceTypeTitle,
        });
      }
    });
    return Array.from(map.values());
  }, [apiItems]);

  function getOriginAndDestination(input, items) {
    const toArray = (list) =>
      Object.entries(list).map(([id, label]) => ({
        id: Number(id),
        label
      }));

    const country0 =
      items.find(item => item.country === 0)?.list || {};

    const country1 =
      items.find(item => item.country === 1)?.list || {};

    if (input === 40) {
      return {
        origin: toArray(country0),
        destination: toArray(country1)
      };
    }

    if (input === 41) {
      return {
        origin: toArray(country1),
        destination: toArray(country0)
      };
    }
    return null;
  }

  return (
    <Box display="flex" flexDirection="column" gap={2}>

      {fields.map((field, index) => {

        const selectedCountry = watch(`Flight.items.${index}.guestServiceType`);

        const originCities = selectedCountry
          ? getOriginAndDestination(parseInt(selectedCountry.guestServiceType), commonData.StationConsistencyByCountryDropDown.items)?.origin
          : [];

        const destCities = selectedCountry
          ? getOriginAndDestination(parseInt(selectedCountry.guestServiceType), commonData.StationConsistencyByCountryDropDown.items)?.destination
          : [];

        return (
          <Box key={field.id} class="mybox">
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12}>
                {/* Service dropdown */}
                <Controller
                  name={`Flight.items.${index}.guestServiceType`}
                  control={control}
                  render={({ field }) => (
                    <Autocomplete
                      {...field}
                      options={flightServiceTypes}
                      getOptionLabel={(o) => o?.guestServiceTypeTitle || ""}

                      onChange={(_, value) => {
                        field.onChange(value);
                        clearErrors(`Flight.items.${index}.guestServiceType`);

                        setValue(
                          `Flight.items.${index}.originStation`,
                          null,
                          { shouldValidate: true }
                        );

                        setValue(
                          `Flight.items.${index}.destinationStation`,
                          null,
                          { shouldValidate: true }
                        );

                        clearErrors([
                          `Flight.items.${index}.guestServiceType`,
                          `Flight.items.${index}.originStation`,
                          `Flight.items.${index}.destinationStation`,
                        ]);

                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="نوع سرویس پرواز"
                          error={!!errors?.Flight?.items?.[index]?.guestServiceType}
                          helperText={
                            errors?.Flight?.items?.[index]?.guestServiceType?.message
                          }
                        />
                      )}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={6}>
                {/* Service dropdown */}
                <Controller
                  name={`Flight.items.${index}.originStation`}
                  control={control}
                  render={({ field }) => (
                    <Autocomplete
                      {...field}
                      options={originCities}
                      getOptionLabel={(o) => o?.label || ""}
                      disabled={!selectedCountry}
                      //onChange={(_, value) => field.onChange(value)}
                      onChange={(_, value) => {
                        field.onChange(value);
                        // reset service when hotel changes
                        clearErrors(`Flight.items.${index}.originStation`);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="ایستگاه مبدأ"
                          error={!!errors?.Flight?.items?.[index]?.originStation}
                          helperText={
                            errors?.Flight?.items?.[index]?.originStation?.message
                          }
                        />
                      )}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={6}>
                {/* Service dropdown */}
                <Controller
                  name={`Flight.items.${index}.destinationStation`}
                  control={control}
                  render={({ field }) => (
                    <Autocomplete
                      {...field}
                      options={destCities}
                      getOptionLabel={(o) => o?.label || ""}
                      disabled={!selectedCountry}
                      //onChange={(_, value) => field.onChange(value)}
                      onChange={(_, value) => {
                        field.onChange(value);
                        // reset service when hotel changes
                        clearErrors(`Flight.items.${index}.destinationStation`);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="ایستگاه مقصد"
                          error={!!errors?.Flight?.items?.[index]?.destinationStation}
                          helperText={
                            errors?.Flight?.items?.[index]?.destinationStation?.message
                          }
                        />
                      )}
                    />
                  )}
                />
              </Grid>

              <Grid item md={6}>
                <Controller
                  control={control}
                  name={`Flight.items.${index}.from`}
                  rules={{ required: true }}
                  render={({
                    field: { onChange, name, value },
                    fieldState: { invalid, isDirty },
                  }) => (
                    <>
                      <DatePicker
                        value={value || ""}
                        onChange={(date) => {
                          onChange(date?.isValid ? date : "");
                          clearErrors(`Flight.items.${index}.from`);
                        }}
                        format={"YYYY/MM/DD"}
                        calendar={persian}
                        locale={persian_fa}
                        calendarPosition="bottom-right"
                        render={<CustomDateInput label={"از تاریخ"}
                          error={!!errors?.Flight?.items?.[index]?.from}
                          helperText={
                            errors?.Flight?.items?.[index]?.from?.message
                          }

                        />}
                      />
                    </>
                  )}
                />
              </Grid>
              <Grid item md={6}>
                <Controller
                  control={control}
                  name={`Flight.items.${index}.to`}
                  rules={{ required: true }}
                  render={({
                    field: { onChange, name, value },
                    fieldState: { invalid, isDirty },
                  }) => (
                    <>
                      <DatePicker
                        value={value || ""}
                        onChange={(date) => {
                          onChange(date?.isValid ? date : "");
                          clearErrors(`Flight.items.${index}.to`);
                        }}
                        format={"YYYY/MM/DD"}
                        calendar={persian}
                        locale={persian_fa}
                        calendarPosition="bottom-right"
                        render={<CustomDateInput label={"تا تاریخ"}
                          error={!!errors?.Flight?.items?.[index]?.to}
                          helperText={
                            errors?.Flight?.items?.[index]?.to?.message
                          }
                        />}
                      />
                    </>
                  )}
                />
              </Grid>
              <Grid item md={12}>
                <CheckboxListFlex
                  name={`Flight.items.${index}.selectPassengersId`}
                  control={control}
                  items={commonData?.allMembers}
                  label="انتخاب نفرات"
                  direction="row"
                  spacing={1}
                  onChange={() => { clearErrors(`Flight.items.${index}.selectPassengersId`); }} // <-- parent onChange
                />
              </Grid>
              <Grid item md={12}>
                <Button variant="outlined" color="error" onClick={() => remove(index)}>
                  حذف
                </Button>
              </Grid>
            </Grid>
          </Box>
        );
      })}

      <Button
        onClick={() =>
          append({
            guestServiceType: null,
            selectPassengersId: [],
            from: "",
            to: "",
            originStation: null,
            destinationStation: null
          })
        }
        variant="text"
        color="primary"
        startIcon={<AddIcon />}
        sx={{ padding: 0, textTransform: 'none', fontSize: 14 }}
      >
         افزودن درخواست {stepData?.title}
      </Button>

      {errors?.Flight?.items?.message && (
        <Typography color="error">
          {errors.Flight.items.message}
        </Typography>
      )}
    </Box>
  );
}

const Section = ({ id, title, icon, section, control, setValue }) => {

  const isTravelStep = id === "TravelPeriodStep";

  function GetPersianDate(input) {
    if (!input) return "";
    let date = new DateObject({ date: input, calendar: persian, locale: persian_fa });
    return `${date.year}/${date.month.number}/${date.day}`;
  }

  const skipStep = () => {
    // مقدار isSkipped در فرم را true می‌کنیم
    setValue(`${id}.isSkipped`, true);
  };

  return (
    <RtlProvider>
      <Accordion disabled={section?.isSkipped}>
        <AccordionSummary expandIcon={<MdExpandMore />}>

          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            width="100%"
          >

            {/* سمت راست (آیکن + عنوان) */}
            <Stack direction="row" spacing={1} alignItems="center">
              <span style={{ fontSize: 20 }}>{icon}</span>
              <Typography fontWeight={600}>{title}</Typography>
            </Stack>

            {/* سمت چپ (نیاز ندارم) */}
            {section?.isSkipped && (
              <Typography
                sx={{
                  color: 'text.secondary',
                  fontSize: 13,
                  opacity: 0.8
                }}
              >
                نیاز ندارم
              </Typography>
            )}

          </Stack>

        </AccordionSummary>
        <AccordionDetails>
          <Stack spacing={2}>
            {/* رندر آیتم‌ها */}
            {section.items?.map((item, index) => (
              <Card key={index} variant="outlined">
                <CardContent>
                  <Stack spacing={1}>
                    {item.guestServiceType?.guestServiceTypeTitle && (
                      <Typography fontWeight={600}>
                        {item.guestServiceType.guestServiceTypeTitle}
                      </Typography>
                    )}
                    {item.originStation && (
                      <Typography color="text.secondary">
                        {item.originStation.label} ← {item.destinationStation.label}
                      </Typography>
                    )}
                    {item.hotelId && (
                      <Typography color="text.secondary">
                        هتل: {item.hotelId.title}
                      </Typography>
                    )}
                    <Box sx={{ display: "flex", gap: 2 }}>
                      {item.from && <Typography color="text.secondary">از: {GetPersianDate(item.from)}</Typography>}
                      {item.to && <Typography color="text.secondary">تا: {GetPersianDate(item.to)}</Typography>}
                    </Box>
                    {item.stArr && (
                      <Stack direction="row" spacing={1}>
                        {item.stArr.map((s) => <Chip key={s.id} label={s.label} />)}
                      </Stack>
                    )}
                    <Stack direction="row" spacing={1}>
                      <Chip size="small" color="secondary" label={`${item.selectPassengersId.length} نفر`} />
                      <Box display="flex" alignItems="center">
                        {item.selectPassengersId.map((n, idx) => (
                          <React.Fragment key={idx}>
                            <Typography>{n.label}</Typography>
                            {idx < item.selectPassengersId.length - 1 && (
                              <Divider orientation="vertical" flexItem sx={{ mx: 1, borderColor: "grey.400" }} />
                            )}
                          </React.Fragment>
                        ))}
                      </Box>
                    </Stack>
                  </Stack>
                </CardContent>
              </Card>
            ))}
          </Stack>
        </AccordionDetails>
      </Accordion>
    </RtlProvider>
  );
};

function Review({ watch, steps, control, register, errors, clearErrors }) {
  const values = watch();

  return (
    <RtlProvider>
      <Box sx={{ p: 3, maxWidth: 900, mx: "auto" }}>
  <TextField
          fullWidth
          multiline
          placeholder="توضیحات"
          {...register(`Review.description`)}
          error={!!errors?.Review?.description}
          helperText={errors?.Review?.description?.message}
          sx={{mt:1,mb:1}}

        />
        <Stack spacing={2}>
          {steps
            .filter((s) => s.id !== "Review" && s.id !== "TravelPeriodStep")  // <-- اینجا فیلتر می‌کنیم
            .map((s) => {
              const sectionData = values[s.id] || {};
              return (
                <Section
                  key={s.id}
                  id={s.id}
                  title={s.title}
                  icon={s.icon}
                  section={sectionData}
                  disabled={sectionData?.isSkipped}
                />
              );
            })}
        </Stack>
      </Box>
    </RtlProvider>
  );
}

/* ------------------ Main Component ------------------ */
export default function ConditionalStepper() {
  const { open, setOpen } = useContext(ContextNotification);
  const { userInfo, userPermissions, userRoles } = useContext(ContextUserInfo);

  const [steps, setSteps] = useState([]);
  const [activeStepId, setActiveStepId] = useState(null);
  const [commonData, setCommonData] = useState(null);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  const {
    register,
    control,
    getValues,
    setError,
    setValue,
    watch,
    clearErrors,
    formState: { errors },
  } = useForm({
    defaultValues: {
      TravelPeriodStep: {},
      Visa: {
        items: [{
          guestServiceType: {
            guestServiceType: enumMapper.GuestServiceType.Visa.toString(),
            guestServiceTypeTitle: "",
          }, selectPassengersId: []
        }]
      },
      Flight: { items: [{ guestServiceType: null, selectPassengersId: [], from: "", to: "", originStation: null, destinationStation: null }] },
      Plan_Mecca: { items: [{ hotelId: null, guestServiceType: null, selectPassengersId: [], from: "", to: "" }] },
      Nutrition_Mecca: {

        items: [{ guestServiceType: null, stArr: [], selectPassengersId: [], from: "", to: "" }]
      },
      Transfer_Mecca: { items: [{ hotelId: null, guestServiceType: null, selectPassengersId: [], from: "", to: "" }] },
      Plan_Medina: { items: [{ hotelId: null, guestServiceType: null, selectPassengersId: [], from: "", to: "" }] },
      Nutrition_Medina: {

        items: [{ guestServiceType: null, stArr: [], selectPassengersId: [], from: "", to: "" }]
      },
      Transfer_Medina: { items: [{ guestServiceType: null, selectPassengersId: [], from: "", to: "" }] },
    },
  });

  // Simple mapping for guestService and city
  const guestServiceMap = {
    0: "Visa",
    1: "Plan",
    2: "Nutrition",
    3: "Transfer",
    4: "Flight"
  };

  const cityMap = {
    2: "Mecca",
    3: "Medina"
  };

  // Function to generate English ID
  function generateEnglishID(guestService, city) {
    const serviceEnglish = guestServiceMap[guestService] || guestService;
    if (!city) return serviceEnglish; // if city is null, undefined, or empty, return only service
    const cityEnglish = cityMap[city] || city;
    return `${serviceEnglish}_${cityEnglish}`;
  }

  const orders = {
    "TravelPeriodStep": 1,
    "Visa": 2,
    "Plan_Mecca": 3,
    "Transfer_Mecca": 4,
    "Nutrition_Mecca": 5,
    "Plan_Medina": 6,
    "Transfer_Medina": 7,
    "Nutrition_Medina": 8,
    "Flight": 9,
    "Review": 10,
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        // First API call
        const res1 = await guestGroupApi.GetGroupInfo();

        const obj = {};

        // add a normal property
        obj.id = res1.data.data.id;

        // add an array property
        obj.allMembers = res1.data.data?.allMembers?.map((r) => {
          return {
            id: r.id,
            label: r.name + ' ' + r.family,
          };
        })

        obj.GroupInfo = res1.data.data;

        // Only runs if first API succeeds
        const res2 = await guestServicesDetailsApi.GetGuestServicesGroupedByCityAndType();

        const res3 = await stationApi.StationConsistencyByCountryDropDown();

        obj.StationConsistencyByCountryDropDown = res3.data;

        setCommonData(obj)

        const mergedChildren = res2.data.data.flatMap(parent =>
          parent.services.map(child => ({
            ...child,
            city: parent.city,
            cityTitle: parent.cityTitle,
            title: child.guestServiceTitle,
          }))
        );
        // Map through data and add EnglishID
        const updatedData = mergedChildren.map(item => ({
          ...item,
          id: generateEnglishID(item.guestService, item.city)
        }));
        const updatedData2 = [{ id: "TravelPeriodStep", title: "بازه سفر" }, ...updatedData, { id: "Review", title: "ثبت نهایی" }]

        const updatedData3 = updatedData2.map(item => ({
          ...item,
          order: orders[item.id] ?? 0
        }));

        updatedData3.sort((a, b) => a.order - b.order);

        const componentMap = {
          TravelPeriodStep,
          Visa,
          Plan_Mecca,
          Transfer_Mecca,
          Nutrition_Mecca,
          Plan_Medina,
          Transfer_Medina,
          Nutrition_Medina,
          Flight,
          Review,
        };

        const iconMap = {
          TravelPeriodStep: <FaRegCalendar />,
          Visa: <FaCcVisa />,
          Plan_Mecca: <FaHotel />,
          Transfer_Mecca: <MdOutlineTrain />,
          Nutrition_Mecca: <GiHotMeal />,
          Plan_Medina: <FaHotel />,
          Transfer_Medina: <MdOutlineTrain />,
          Nutrition_Medina: <GiHotMeal />,
          Flight: <PiAirplaneInFlightFill />,
          Review: <FaKaaba />,
        };

        const apiSteps = updatedData3.map((s) => ({
          ...s,
          component: componentMap[s.id] || null,
          icon: iconMap[s.id] || null,
        }));




        setSteps(apiSteps);
        if (apiSteps.length > 0) setActiveStepId(apiSteps[0].id);

      } catch (error) {
        console.error("API error:", error);
      }
      finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const activeIndex = steps.findIndex((s) => s.id === activeStepId);
  const ActiveComponent = steps[activeIndex]?.component;

  const startTrip = useWatch({
    control,
    name: "TravelPeriodStep.startTrip"
  });

  const endTrip = useWatch({
    control,
    name: "TravelPeriodStep.endTrip"
  });

  function GetPersianDate(input) {
    let dateStr = '';
    if (input) {
      let date = new DateObject({
        date: input,
        calendar: persian,
        locale: persian_fa
      });
      dateStr = date.year + '/' + date.month.number + '/' + date.day;
    }
    return dateStr;
  }

  const isTravelStep = activeStepId === "TravelPeriodStep";

  const validateStep = async (stepId, onSuccess) => {
    const stepData = getValues()[stepId];

    if (stepId === "TravelPeriodStep") {
      // TravelPeriodStep always validated
      try {
        await stepSchemas.TravelPeriodStep.validate(stepData, { abortEarly: false });
        onSuccess();
      } catch (err) {
        err.inner.forEach((e) =>
          setError(`TravelPeriodStep.${e.path}`, { type: "manual", message: e.message })
        );
      }
      return;
    }

    try {
      await stepSchemas[stepId].validate(stepData, {
        abortEarly: false, context: {
          startTrip: getValues().TravelPeriodStep.startTrip,
          endTrip: getValues().TravelPeriodStep.endTrip,
        }
      });
      onSuccess();
    } catch (err) {
      err.inner.forEach((e) =>
        setError(`${stepId}.${e.path}`, { type: "manual", message: e.message })
      );
    }
  };

  const next = () =>
    validateStep(activeStepId, () => {

      // اگر قبلاً skip شده بود، حالا که فرم پر شده ریستش کن
      setValue(`${activeStepId}.isSkipped`, false);

      if (activeIndex < steps.length - 1) {
        setActiveStepId(steps[activeIndex + 1].id);
      }
    });
  const prev = () => {
    if (activeIndex > 0) setActiveStepId(steps[activeIndex - 1].id);
  };

  // تابع skipStep
  const skipStep = () => {
    if (activeIndex < steps.length - 1) {
      // مقدار isSkipped را برای استپ فعال ثبت می‌کنیم
      setValue(`${activeStepId}.isSkipped`, true);
      setActiveStepId(steps[activeIndex + 1].id);
    }
  };

  function GetGregorianDate(input) {
    let dateGregorian = null;
    if (input) {
      let date = new DateObject({
        date: input,
        calendar: persian,
        locale: persian_fa
      });

      var dateStr = date.year + '/' + date.month.number + '/' + date.day;
      dateGregorian = moment.from(dateStr, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD')
    }
    return dateGregorian
  }

  // const submit = () => alert(JSON.stringify(getValues(), null, 2));
  const submit = () => {
    const values = getValues();

    // console.log("values", values)

    //startTripGregorian
    let startTripGregorian = null;
    if (values.TravelPeriodStep.startTrip) {
      let startTrip = new DateObject({
        date: values.TravelPeriodStep.startTrip,
        calendar: persian,
        locale: persian_fa
      });

      var startTripStr = startTrip.year + '/' + startTrip.month.number + '/' + startTrip.day;
      startTripGregorian = moment.from(startTripStr, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD')
    }
    //endTripGregorian
    let endTripGregorian = null;
    if (values.TravelPeriodStep.endTrip) {
      let endTrip = new DateObject({
        date: values.TravelPeriodStep.endTrip,
        calendar: persian,
        locale: persian_fa
      });

      var endTripStr = endTrip.year + '/' + endTrip.month.number + '/' + endTrip.day;
      endTripGregorian = moment.from(endTripStr, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD')
    }

    const servicesRequest = [];

    Object.entries(values).forEach(([sectionKey, sectionValue]) => {
      if (sectionValue?.isSkipped) return; // نادیده گرفتن skip
      if (!Array.isArray(sectionValue.items)) return;

      sectionValue.items.forEach(item => {
        switch (sectionKey) {
          case "Visa":
            servicesRequest.push({
              guestServices: enumMapper.GuestServices.Visa,
              guestServiceType: Number(item.guestServiceType?.guestServiceType),
              cityConsistency: null,
              hotelId: null,
              selectPassengersId: item.selectPassengersId.map(x => x.id),
              from: null,
              to: null
            });
            break;

          case "Flight":
            servicesRequest.push({
              guestServices: enumMapper.GuestServices.Flight,
              guestServiceType: Number(item.guestServiceType?.guestServiceType),
              cityConsistency: null,
              hotelId: null,
              selectPassengersId: item.selectPassengersId.map(x => x.id),
              from: GetGregorianDate(item.from),
              to: GetGregorianDate(item.to),
              originStation: item.originStation?.id ? Number(item.originStation.id) : null,
              destinationStation: item.destinationStation?.id ? Number(item.destinationStation.id) : null,
            });
            break;

          case "Plan_Mecca":
            servicesRequest.push({
              guestServices: enumMapper.GuestServices.Plan,
              guestServiceType: Number(item.guestServiceType?.guestServiceType),
              cityConsistency: enumMapper.CityConsistency.Mecca,
              hotelId: item.hotelId?.hotelId ? item.hotelId.hotelId : null,
              selectPassengersId: item.selectPassengersId.map(x => x.id),
              from: GetGregorianDate(item.from),
              to: GetGregorianDate(item.to)
            });
            break;

          case "Nutrition_Mecca":
            for (let index = 0; index < item.stArr.length; index++) {
              const element = item.stArr[index];
              servicesRequest.push({
                guestServices: enumMapper.GuestServices.Nutrition,
                guestServiceType: Number(element.id),
                cityConsistency: enumMapper.CityConsistency.Mecca,
                hotelId: null,
                selectPassengersId: item.selectPassengersId.map(x => x.id),
                from: GetGregorianDate(item.from),
                to: GetGregorianDate(item.to)
              });
            }

            break;

          case "Transfer_Mecca":
            servicesRequest.push({
              guestServices: enumMapper.GuestServices.Transfer,
              guestServiceType: Number(item.guestServiceType?.guestServiceType),
              cityConsistency: enumMapper.CityConsistency.Mecca,
              hotelId: null,
              selectPassengersId: item.selectPassengersId.map(x => x.id),
              from: GetGregorianDate(item.from),
              to: GetGregorianDate(item.to)
            });
            break;

          case "Plan_Medina":
            servicesRequest.push({
              guestServices: enumMapper.GuestServices.Plan,
              guestServiceType: Number(item.guestServiceType?.guestServiceType),
              cityConsistency: enumMapper.CityConsistency.Medina,
              hotelId: item.hotelId?.hotelId ? item.hotelId.hotelId : null,
              selectPassengersId: item.selectPassengersId.map(x => x.id),
              from: GetGregorianDate(item.from),
              to: GetGregorianDate(item.to)
            });
            break;

          case "Nutrition_Medina":
            for (let index = 0; index < item.stArr.length; index++) {
              const element = item.stArr[index];
              servicesRequest.push({
                guestServices: enumMapper.GuestServices.Nutrition,
                guestServiceType: Number(element.id),
                cityConsistency: enumMapper.CityConsistency.Medina,
                hotelId: null,
                selectPassengersId: item.selectPassengersId.map(x => x.id),
                from: GetGregorianDate(item.from),
                to: GetGregorianDate(item.to)
              });
            }

            break;

          case "Transfer_Medina":
            servicesRequest.push({
              guestServices: enumMapper.GuestServices.Transfer,
              guestServiceType: Number(item.guestServiceType?.guestServiceType),
              cityConsistency: enumMapper.CityConsistency.Medina,
              hotelId: null,
              selectPassengersId: item.selectPassengersId.map(x => x.id),
              from: GetGregorianDate(item.from),
              to: GetGregorianDate(item.to)
            });
            break;
        }
      });
    });

    // console.log(servicesRequest);

    const newData = {
      "guestGroupID": commonData?.id,
      "startTrip": startTripGregorian,
      "endTrip": endTripGregorian,
      "description": values.Review.description,
      "servicesRequest": servicesRequest
    }

    guestRequestApi.CreateFirstGroupRequests(newData)
      .then(res => {
        if (res.data.success) {
          setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.success });
          navigate("/Dashboard/Requests");
        }
        else {
          setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.error });
        }
      })
      .catch(err => {
        if (err.response && err.response.data && err.response.data.errors) {
          setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
        }
        else if (err.response && err.response.data) {
          setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
        }
        else if (err.message) {
          setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
        }
        else {
          setOpen({ IsEnable: true, Message: JSON.stringify(err), severity: severitys.error });
        }
      }
      ).finally(() => { });
  };


  function CustomStepIcon({ active, icon }) {
    const step = steps[icon - 1]; // MUI به صورت 1-indexed

    return (
      <div
        style={{
          width: 40,
          height: 40,
          borderRadius: "50%",
          backgroundColor: active ? "#1976d2" : "#bdbdbd",
          color: "white",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 20,
        }}
      >
        {step.icon} {/* اینجا می‌توانی هم آیکن هم عدد بذاری */}
      </div>
    );
  }
  const CustomConnector = styled(StepConnector)(({ theme }) => ({
    "& .MuiStepConnector-line": {
      minHeight: 40,          // حداقل ارتفاع
      borderLeftWidth: 2,
    },
    "&.MuiStepConnector-vertical": {
      marginLeft: 20,         // تنظیم موقعیت دقیق خط
    },
  }));
  return (
    <RtlProvider>
      {loading ? (
        <div>در حال بارگذاری...</div>
      ) : !commonData ? (
        <>اطلاعات کاربری را تکمیل فرمایید</>
      ) : commonData.GroupInfo?.requests?.length ? (
        <Card sx={{ maxWidth: 400, m: 'auto', mt: 3, border: '1px solid #ddd' }}>
          <CardContent>
            <Typography variant="h5" align="center">وضعیت درخواست</Typography>
            <Box display="flex" flexDirection="column" alignItems="center" mt={2}>
              <Typography variant="h6" color="text.secondary" align="center">
                {commonData?.GroupInfo?.guestGroupStepTitle}
              </Typography>
            </Box>
          </CardContent>
        </Card>
      ) : steps.length > 0 ? (
        <Box maxWidth={900} mx="auto" p={2}>



          {/* Sticky Header */}
          <Box
            position="sticky"
            top={64}
            bgcolor="white"
            zIndex={(theme) => theme.zIndex.drawer + 1}
            borderBottom="1px solid #ddd"
          >

            {/* ردیف بازه سفر */}
            {startTrip && endTrip && activeStepId !== 'TravelPeriodStep' && (
              <Box px={2} pt={1} pb={1}>

                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  gap={2}
                >

                  {/* شروع سفر */}
                  <Box
                    display="flex"
                    alignItems="center"
                    gap={1}
                    sx={{
                      backgroundColor: '#1976d2',
                      color: 'white',
                      px: 1.5,
                      py: 0.5,
                      borderRadius: 2,
                      fontSize: 13,
                      fontWeight: 500,
                      whiteSpace: 'nowrap'
                    }}
                  >
                    <CalendarTodayIcon sx={{ fontSize: 16 }} />
                    {GetPersianDate(startTrip)}
                  </Box>

                  {/* خط وسط + متن */}
                  <Box
                    flex={1}
                    display="flex"
                    alignItems="center"
                    gap={1}
                  >
                    <Box flex={1} height="1px" bgcolor="#ccc" />
                    <Typography
                      variant="caption"
                      sx={{
                        whiteSpace: 'nowrap',
                        fontWeight: 600,
                        color: '#666'
                      }}
                    >
                      بازه سفر
                    </Typography>
                    <Box flex={1} height="1px" bgcolor="#ccc" />
                  </Box>

                  {/* پایان سفر */}
                  <Box
                    display="flex"
                    alignItems="center"
                    gap={1}
                    sx={{
                      backgroundColor: '#1976d2',
                      color: 'white',
                      px: 1.5,
                      py: 0.5,
                      borderRadius: 2,
                      fontSize: 13,
                      fontWeight: 500,
                      whiteSpace: 'nowrap',
                    }}
                  >
                    <CalendarTodayIcon sx={{ fontSize: 16 }} />
                    {GetPersianDate(endTrip)}
                  </Box>

                </Box>
              </Box>
            )}

            {/* عنوان مرحله فعال */}
            <Box py={1}>
              <Typography
                variant="h6"
                color="primary"
                align="center"
                sx={{ fontWeight: 600 }}
              >
                {steps[activeIndex]?.title}
              </Typography>
            </Box>

          </Box>

          {/* Stepper */}
          <Stepper activeStep={activeIndex} orientation="vertical" connector={<CustomConnector />} sx={{ mt: 2 }}>
            {steps.map((s, i) => (
              <Step key={s.id}>
                <StepLabel StepIconComponent={CustomStepIcon} sx={{
                  '& .MuiStepLabel-label': {
                    fontSize: '1.2rem',            // bigger font
                    fontWeight: activeIndex === i ? 'bold' : 'normal',
                    color: activeIndex === i ? '#1976d2' : 'text.primary', // active step color
                  },
                }}>{s.title}</StepLabel>
                <Box mt={1}>
                  {activeIndex === i && ActiveComponent && (
                    <ActiveComponent
                      register={register}
                      control={control}
                      setValue={setValue}
                      errors={errors}
                      watch={watch}
                      clearErrors={clearErrors}
                      stepData={steps[i]}
                      steps={steps}
                      commonData={commonData}
                    />
                  )}
                </Box>
              </Step>
            ))}
          </Stepper>

          {/* Sticky Footer */}
         <Box
            position="sticky"
            bottom={0}
            bgcolor="white"
            zIndex={(theme) => theme.zIndex.drawer + 1}
            p={2}
            borderTop="1px solid #ddd"
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
									 
            <Box>
              {activeIndex > 0 && (
                <Button variant="contained" color="secondary" onClick={prev}>
                  قبلی
                </Button>
              )}
            </Box>

																				 
            <Box display="flex" gap={2}>
              {activeIndex < steps.length - 1 ? (
                <>
                  <Button variant="contained" color="secondary" onClick={next} size="small">
                    تأیید {steps[activeIndex].title}
                  </Button>
                  {activeStepId !== 'TravelPeriodStep' && (
                    <Button variant="contained" color="warning" onClick={skipStep} size="small">
                      نیاز ندارم
                    </Button>
                  )}
                </>
              ) : (

													
                <Button variant="contained" color="success" onClick={submit}>
                  تأیید
                </Button>
              )}
            </Box>
          </Box>
        </Box>
      ) : null}
    </RtlProvider>
  );
}
